import { LetterSpacing } from './letterSpacing';

export * from './letterSpacing';

export default LetterSpacing;
